import axios from 'axios';
import { ENV } from '../configs/appConfig';
import logger from './logService';

const instance = axios.create({
  baseURL: ENV.baseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

const axiosRequestHandler = (request) => {
  if (!request.url.includes('auth')) {
    const token = localStorage.getItem('tokenId');
    request.headers.token = token;
  }
  return request;
};

const axiosResponseHandler = (response) => {
  return Promise.resolve(response);
};

const axiosErrorHandler = async (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid — clear session and redirect
      localStorage.clear();
      window.location.href = '/login';
      return;
    }
  
    if (error.response?.status === 405) {
      window.location.href = '/not-authorized';
    }
  
    const expectedError = error.response && error.response.status >= 400 && error.response.status < 500;
    if (!expectedError) {
      console.error(error);
    }
  
    return Promise.reject(error);
  };

// Intercepting API requests
instance.interceptors.request.use(axiosRequestHandler);

// Intercepting API responses
instance.interceptors.response.use(axiosResponseHandler, axiosErrorHandler);

export default instance;
